/**
 * Plus 席位授权相关 Hooks
 */

import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query'
import {
  assignClientPlus,
  getClientPlusSummary,
  listClientPlusUsers,
  unassignClientPlus,
} from '@/services/clientPlusService'
import type { ClientPlusSummary, ClientPlusUsersData } from '@/types/clientPlus'

export const CLIENT_PLUS_SUMMARY_QUERY_KEY = ['client-plus', 'summary'] as const
export const CLIENT_PLUS_USERS_QUERY_KEY = ['client-plus', 'users'] as const

export function useClientPlusSummary(): UseQueryResult<ClientPlusSummary> {
  return useQuery({
    queryKey: CLIENT_PLUS_SUMMARY_QUERY_KEY,
    queryFn: getClientPlusSummary,
  })
}

export function useClientPlusUsers(): UseQueryResult<ClientPlusUsersData> {
  return useQuery({
    queryKey: CLIENT_PLUS_USERS_QUERY_KEY,
    queryFn: listClientPlusUsers,
  })
}

export function useAssignClientPlus(): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: assignClientPlus,
    onSuccess: (): void => {
      void queryClient.invalidateQueries({ queryKey: CLIENT_PLUS_SUMMARY_QUERY_KEY })
      void queryClient.invalidateQueries({ queryKey: CLIENT_PLUS_USERS_QUERY_KEY })
    },
  })
}

export function useUnassignClientPlus(): UseMutationResult<void, Error, string> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: unassignClientPlus,
    onSuccess: (): void => {
      void queryClient.invalidateQueries({ queryKey: CLIENT_PLUS_SUMMARY_QUERY_KEY })
      void queryClient.invalidateQueries({ queryKey: CLIENT_PLUS_USERS_QUERY_KEY })
    },
  })
}
